<template>
  <TransactionListTemplate
    :backButtonEnable="true"
    :backButtonRoute="'/settings/accounting'"
    :screenConfig="setScreenConfig"
    :persistenceKey="'accounting-periods-list'"
    ref="accounting-periods-list"
    :setLoading="setLoading"
    v-if="loaded"
  >
    <template #popup>
      <GcPopupLockAccountingPeriod
        :popupConfig="lockPeriodPopupConfig"
        :onHide="onLockPeriodPopupHide"
        v-if="lockPeriodPopupConfig.isPopupShow"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../../templates/transaction-list";
import GcPopupLockAccountingPeriod from "../../../popups/accounting/gc-popup-lock-accounting-period.vue";
import { FeatureStorage } from "../../../_services/storage";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
    GcPopupLockAccountingPeriod,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      lockPeriodPopupConfig: {
        isPopupShow: false,
      },
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Accounting Periods",
        ScreenName: "AccountingPeriods",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AccountingPeriod",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "Code",
                "DateStart",
                "DateEnd",
                "CalendarMonth",
                "FiscalYear",
                "Status",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Accounting Periods",
                message: "Get Started, Add an Accounting Period",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "lock",
                label: "Lock Period",
                clickAction: this.openLockPeriodPopup,
                buttonLocation: "left",
                elementAttr: { class: "cx-color-button" },
                visible: FeatureStorage.checkPermission(
                  "AccountingPeriods",
                  "create",
                ),
              },
            ],
            filterOnEnter: true,
          },
          columns: [
            {
              screenField: "Code",
              dataField: "Code",
              label: "ID",
            },
            {
              screenField: "Date",
              dataField: "DateStart",
              label: "Start Date",
            },
            {
              screenField: "Date",
              dataField: "DateEnd",
              label: "End Date",
              sortOrder: "desc",
              sortIndex: 0,
            },
            {
              dataField: "CalendarMonth",
              label: "Calendar Month",
              width: 100,
              minWidth: 100,
            },
            {
              screenField: "FiscalYearSelect",
              dataField: "FiscalYear",
              label: "Fiscal Year",
              width: 100,
              minWidth: 100,
              filterDataField: "FiscalYear",
              filterIndex: 1,
              filterLabel: "Fiscal Year",
            },
            {
              dataField: "Status",
              label: "Status",
              cellTemplate: "Status",
              customBackGroundColor: (data) => {
                if (data) {
                  if (data.Status === "Open") return "#4caf50";
                  else if (data.Status === "Locked") return "#f44336";
                  return undefined;
                } else return undefined;
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    openLockPeriodPopup() {
      this.lockPeriodPopupConfig.isPopupShow = true;
    },
    onLockPeriodPopupHide() {
      this.lockPeriodPopupConfig.isPopupShow = false;
    },
  },

  created() {
    this.setLoading = true;
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
